import React, { useEffect, useState } from "react";
import styles from './EvaluationNotes.module.scss';
import {ReactComponent as XIcon} from './X.svg';
import Button from "../button/Button";
import Icon from "../icon/Icon";
import PropTypes from "prop-types";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";

const EvaluationNotes = ({
  note: initialNote,
  onSave,
  onClose,
  isLoading,
  disabled,
}) => {
  const [note, setNote] = useState('');

  useEffect(() => {
    setNote(initialNote);
  }, [initialNote]);

  return (
    <div className={styles.container}>
      <div className={styles.close}>
        <XIcon onClick={onClose} />
      </div>
      <label>Notes</label>
      <textarea
        placeholder="Add Notes"
        value={note}
        onChange={({ target: { value } })=> {
          setNote(value);
        }}
        disabled={disabled}
      />
      <div className={styles.footer}>
        <div className={styles.help}>
          <Icon name="lock" />
          <div className={styles.text}>
            <label>Private </label>
            <span>Only visible to the director / program admin</span>
          </div>
        </div>
        <div>
        {isLoading ? 
          <LoadingSpinner size={20} /> :
          <Button
            label="Save&nbsp;Note"
            variant="black"
            onClick={() => onSave(note)}
            disabled={!note || disabled}
          />}
        </div>
      </div>
    </div>
  );
};

EvaluationNotes.propTypes = {
  note: PropTypes.string,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default EvaluationNotes;